<template>
  <div>
    <First v-if="data.pessoa && data.registro"
           :pessoa="data.pessoa"
           :obito-id="data.obito_id"
           :registro="data.registro"
           :prop-obito="dados"
           @onGoEditarObito="editarObito()"
           @updateObito="updateObito"
           @reloadObito="reload" />

    <Second
      :data="data" />

    <Third
      :pessoa="data.pessoa"
      :deixa-filhos="data.deixa_filhos"
      :filho-deixado="data.filhoDeixado"
      :partes="data.registro ? data.registro.partes : []"
      :deixa-bens="data.deixa_bens"
      :deixa-testamento="data.deixa_testamento"
      :reservista="data.reservista"
      :eleitor-ativo="data.eleitor_ativo" />

    <Fourth :data="data" />

    <b-modal v-if="propNumeroPedidoPossueCertidaoEletronica"
             id="aviso-numero-pedido-possui-certidao-eletronica"
             size="md"
             hide-header
             hide-footer
             no-close-on-backdrop
             no-close-on-esc
             centered>
      <p class="mt-3">
        Já foi criada uma OS nº <strong style="font-size: 1.2rem;">{{ propPedidoPendente.numPedidoPossueOrdemServico.numero }}</strong> e gerada uma certidão eletrônica <a 
          :href="propPedidoPendente.numPedidoPossueCertidaoEletronica.link_assinatura"
          target="_blank" 
          rel="noopener noreferrer">
          <img 
            src="https://arpen-header-footer-prod.codebit.biz/assets/images/header/registro-civil-logo.svg" 
            alt="Abrir certidão eletrônica"
            style="height: 20px; vertical-align: middle;">
        </a> &nbsp; para o pedido nº <strong style="font-size: 1.2rem;">{{ propPedidoPendente.pedido_certidao_id }}</strong>.
      </p>
      <p>Deseja cumprir este pedido?</p>
      <div class="d-flex justify-content-end mt-4">
        <b-button
          class="btn-numero-pedido-possui-certidao-eletronica mr-3"
          @click="$bvModal.hide('aviso-numero-pedido-possui-certidao-eletronica'), $emit('fecharModalAvisoNumeroPedidoPossuiCertidaoEletronica', false, 'Sim')">
          Sim
        </b-button>
        <b-button
          style="background: #6c757d; border-color: #6c757d;"
          class="btn-numero-pedido-possui-certidao-eletronica"
          @click="$bvModal.hide('aviso-numero-pedido-possui-certidao-eletronica'), $emit('fecharModalAvisoNumeroPedidoPossuiCertidaoEletronica', false, 'Não')">
          Não
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import First from "../../Obito/Visualizacao/First"
  import Second from "../../Obito/Visualizacao/Second"
  import Third from "../../Obito/Visualizacao/Third"
  import Fourth from "../../Obito/Visualizacao/Fourth"
  export default {
    name: "ResumoDetalhes",
    components: {
      First,
      Second,
      Third,
      Fourth,
    },
    props: ["data", "propPedidoPendente", "propNumeroPedidoPossueCertidaoEletronica"],
    data () {
      return {
        dados: {}
      }
    },
    watch: {
      data () {
        this.dados = this.data
      }
    },
    methods: {
      editarObito () {
        const router_name = this.data.registro.status === 'RASCUNHO' ? "editar_obito_rascunho" : "editar_obito"
        return this.$router.push({name: router_name, params: { id: this.data.obito_id, propObito: this.data.registro.status === 'RASCUNHO' ? null : this.data }})
      },
      updateObito (data) {
        this.dados = data
      },
      reload () {
        this.$emit('reloadObito', true)
      }
    },
  }
</script>

<style lang="scss">
    @import "../../../../scss/_components/resumos";

    .btn-gray{
        background-color: $color-gray-light;
    }

    .btn-numero-pedido-possui-certidao-eletronica {
      padding: 0.2rem 2rem;
      border-radius: 4px;
      font-size: 1rem;
    }
</style>
